<template>
  <div class="baseInfoForm rj-page-card">
    <div class="rj-page-card__content">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
      >
        <div class="rj-row">
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                到款状态：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="remittanceState">
                  <el-select v-model="form.remittanceState" placeholder="请选择">
                    <el-option
                      v-for="item in selectOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                确认到账日期：
              </div>
              <div class="rj-baseinfo__item">
                <el-date-picker
                  v-model="form.arriveTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  clearable
                />
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际到款金额：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="actualRemittanceAmount">
                  <!-- <el-input-number
                    v-model="form.actualRemittanceAmount"
                    :min="0"
                    :max="maxAmount"
                    :controls="true"
                    @input="completeAmount"
                  /> -->
                  <span>{{ baseInfo.actualRemittanceAmount }}</span>
                  <!-- <span>{{ form.actualRemittanceAmount }}</span> -->
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                手续费：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="actualRemittanceAmount">
                  <span v-if="baseInfo.numberAccount">{{ baseInfo.numberAccount }}</span>
                  <span v-else>----</span>
                  <span>{{ baseInfo.currencyName }}</span>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <LCfile v-if="form.remittanceState=='5'" ref="LCfile" />
  </div>
</template>

<script>
// import { onUpdated } from 'vue';
import LCfile from './LCfile'; ;
export default {
  name: 'FormInput',
  props: {
    baseInfo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {
    LCfile
  },
  data () {
    return {
      // options: [[{
      //   value: '1',
      //   label: '待确认到账'
      // }, {
      //   value: '2',
      //   label: '待核查户到账'
      // }, {
      //   value: '3',
      //   label: '一般户到账'
      // } ], [{
      //   value: '4',
      //   label: '未收到LC'
      // }, {
      //   value: '5',
      //   label: '收到LC正本'
      // }, {
      //   value: '6',
      //   label: '确认到账'
      // }]],
      options: [[{
        value: '3',
        label: '一般户到账'
      } ], [ {
        value: '6',
        label: '确认到账'
      }]],
      form: {
        actualRemittanceAmount: null,
        remittanceState: null,
        arriveTime: ''
      },
      maxAmount: 0,
      numberAccount: 0,
      numb: '',
      rules: {
        // 'actualRemittanceAmount': [
        //   { required: true, message: '请输入实际到款金额', trigger: 'change' }
        // ],
        'remittanceState': [
          { required: true, message: '请选择到款状态', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    selectOptions () {
      if (this.baseInfo.remittanceWay === 1) {
        return this.options[0];
      }

      if (this.baseInfo.remittanceWay === 2) {
        return this.options[1];
      }
      return [];
    }
  },
  watch: {
    baseInfo (val) {
      this.form.actualRemittanceAmount = this.baseInfo.actualRemittanceAmount;
      this.form.remittanceState = val.remittanceState ? String(val.remittanceState) : this.form.remittanceState;
      this.completeAmount();
      this.maxAmount = val.remittanceAmount;
      this.syncRemittanceState();
    },
    selectOptions: {
      handler () {
        this.syncRemittanceState();
      },
      immediate: true
    },
    'baseInfo.actualRemittanceAmount': {
      handler (newVal, oldVal) {
        if (typeof newVal !== typeof 0) {
          this.baseInfo.numberAccount = '';
        }
      },
      immediate: true
    }
  },
  // mounted () {
  //   console.log(this.baseInfo);
  // },
  methods: {
    syncRemittanceState () {
      const values = this.selectOptions.map(item => item.value);

      if (!values.length) {
        this.form.remittanceState = null;
        return;
      }

      if (!values.includes(this.form.remittanceState)) {
        this.form.remittanceState = values[0];
      }
    },
    // 验证表单
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then(async () => {
          let files = [];
          if (this.$refs.LCfile) {
            files = this.$refs.LCfile.tableData;
          }
          this.form.actualRemittanceAmount = this.baseInfo.actualRemittanceAmount;
          resolve({ form: this.form, lcFiles: files || [] });
        }).catch(() => {
          this.$message.error('请填写完整信息');
          resolve(false);
        });
      });
    },
    completeAmount () {
      // this.numberAccount = (this.baseInfo.remittanceAmount - this.baseInfo.actualRemittanceAmount).toFixed(2);
      this.baseInfo.numberAccount = (this.baseInfo.remittanceAmount - this.baseInfo.actualRemittanceAmount).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
